import Vue from "vue";
export default Vue.extend({
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
    },
});
